/**
 * @generated SignedSource<<9a48d89c12d8e3003387445d3cae3a15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteTalentProfileInput = {
  clientMutationId?: string | null | undefined;
  talentProfileId: string;
};
export type OpsTalentEditPageDeleteMutation$variables = {
  input: DeleteTalentProfileInput;
};
export type OpsTalentEditPageDeleteMutation$data = {
  readonly deleteTalentProfile: {
    readonly deletedId: string | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsTalentEditPageDeleteMutation = {
  response: OpsTalentEditPageDeleteMutation$data;
  variables: OpsTalentEditPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTalentProfilePayload",
    "kind": "LinkedField",
    "name": "deleteTalentProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsTalentEditPageDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsTalentEditPageDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a3687e852a2039ba747338e1f6439110",
    "id": null,
    "metadata": {},
    "name": "OpsTalentEditPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OpsTalentEditPageDeleteMutation(\n  $input: DeleteTalentProfileInput!\n) {\n  deleteTalentProfile(input: $input) {\n    deletedId\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa80dbc09eaaec20e1f88b2fe889aa82";

export default node;
